const messages: Record<string, string> = {
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are three steps away from finishing the process',
	'waitForAudit.thankYou': 'We appreciate your feedback!',
	'waitForAudit.description.damageFound': 'Thank you for trusting in Allianz!',
	'thanks.paragraph.first': 'Thank you for trusting in Allianz!',
	'timeout.headline.first': 'The link to the application has expired and is no longer active.',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
